import {Component, Input} from "@angular/core";
import {DecimalPipe} from "@angular/common";


@Component({
    selector: 'app-kosten-sparpotenzial',
    templateUrl: './kosten-sparpotenzial.component.html',
    standalone: false
})

export class KostenSparpotenzialComponent {

  /**
   * toggle if this is an internal project or not.
   */
  @Input() internalPortal: boolean;

  /**
   * Placeholder used in all texts
   */
  @Input() textPlaceholder: any;

  /**
   * textkey prefix
   */
  @Input() textkeyPrefix: string;

  /**
   * image path
   */
  @Input() imagePath: string;

  /**
   * optional textkey for showing teaser text under headline
   */
  @Input() teaser?: string;

  /**
   * Represents the amount of savings in euros for a specific year.
   *
   * @type {any}
   */
  @Input() savingsEuroYear?: any;

  /**
   * Represents the stage of a process.
   *
   * @type {number}
   */
  @Input() stage?: number;

  /**
   * holds optional textkey to show a timespan beside savingsEuroYear
   *
   */
  @Input() showTimespan?: boolean;

}
